module.exports = __webpack_public_path__ + "media/images/app/homepage/banner-experience-9bc33b9d5108981c867ff82b1370b43f.webp";